
export interface WizardData {
    usergroupId: string | undefined
    username: string | undefined
}

export function cleanData(): WizardData {
    return {
        usergroupId: undefined,
        username: undefined
    }
}